// extracted by mini-css-extract-plugin
var _1 = "eP9xoorU";
var _2 = "pk1AvxVp";
var _3 = "X5sy9yBB";
export { _1 as "statistics_icon", _2 as "statistics_info", _3 as "statistics_wrapper" }
